import { AddModalContainer } from "./AddModalContainer";

export default AddModalContainer;
